module.exports = __webpack_public_path__ + "static/media/数字孪生行业应用-智慧工厂-01.e97f407d.jpg";